import type { AddressForBookingOutputRecord } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';

type UseAddressMapNavigationOptions = {
  brandDomains?: string[];
  onAddressResolved?: (address: AddressForBookingOutputRecord) => void;
};

export const useAddressMapNavigation = (options?: UseAddressMapNavigationOptions) => {
  const {
    mutateAsync: createAddressFromPlaceId,
    isPending,
    reset,
    data: addressResponse,
    error
  } = noddiAsync.usePost({
    type: URLKeys.postAddressCreatedFromPlaceId,
    queryConfig: {
      onSuccess: (data) => {
        options?.onAddressResolved?.(data.data);
      }
    }
  });

  const address = addressResponse?.data;

  const handleSelect = async (suggestion: { placeId: string }) => {
    await createAddressFromPlaceId({
      placeId: suggestion.placeId,
      brandDomains: options?.brandDomains
    });
  };

  const handleClear = () => {
    reset();
  };

  return { address, isPending, error, handleSelect, handleClear };
};
